__turbopack_context__.v({
  "dataCell": "PointsTable-module-scss-module__PA6SYq__dataCell",
  "flagIcon": "PointsTable-module-scss-module__PA6SYq__flagIcon",
  "groupName": "PointsTable-module-scss-module__PA6SYq__groupName",
  "headerCell": "PointsTable-module-scss-module__PA6SYq__headerCell",
  "headingText": "PointsTable-module-scss-module__PA6SYq__headingText",
  "negativeNrr": "PointsTable-module-scss-module__PA6SYq__negativeNrr",
  "nrrCell": "PointsTable-module-scss-module__PA6SYq__nrrCell",
  "pointsTable": "PointsTable-module-scss-module__PA6SYq__pointsTable",
  "tableBody": "PointsTable-module-scss-module__PA6SYq__tableBody",
  "tableContainer": "PointsTable-module-scss-module__PA6SYq__tableContainer",
  "tableDiv": "PointsTable-module-scss-module__PA6SYq__tableDiv",
  "tableHead": "PointsTable-module-scss-module__PA6SYq__tableHead",
  "tableHeader": "PointsTable-module-scss-module__PA6SYq__tableHeader",
  "tableRow": "PointsTable-module-scss-module__PA6SYq__tableRow",
  "tableWrapper": "PointsTable-module-scss-module__PA6SYq__tableWrapper",
  "teamCell": "PointsTable-module-scss-module__PA6SYq__teamCell",
});
